"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
/**
 * Wrapper class for managing react-native iOS notifications
 */
class IosNotifyWrapper {
    /**
     * @constructor
     * @param {string} params.applicationId notifications application ID
     * @param {boolean} params.usePushkit send and receive messages via IOS pushkit
     * @param {IosNotifications} params.ios native IOS notifications instance
     */
    constructor(params) {
        this.applicationId = params.applicationId;
        this.usePushkit = params.usePushkit;
        this.ios = params.ios;
        this.tokenObservable = this.createTokenObservable();
        this.messageObservable = this.createMessageObservable();
        this.ios.consumeBackgroundQueue();
        if (this.usePushkit) {
            this.ios.registerPushKit();
        }
        else {
            this.ios.requestPermissions();
        }
    }
    /**
     * Gets notification microservice application ID
     */
    getApplicationId() {
        return this.applicationId;
    }
    /**
     * Gets transport for this instance
     */
    getTransport() {
        return this.usePushkit ? 'apns-voip' : 'apns';
    }
    /**
     * Provides token change stream
     */
    asTokenObservable() {
        return this.tokenObservable;
    }
    /**
     * Provides notifications message stream
     */
    asMessageObservable() {
        return this.messageObservable;
    }
    /**
     * Gets mobile token
     */
    getToken() {
        if (this.token) {
            return Promise.resolve(this.token);
        }
        else {
            return new Promise((resolve, reject) => {
                this.asTokenObservable()
                    .first()
                    .subscribe(event => resolve(event.newToken), error => reject(error));
            });
        }
    }
    createTokenObservable() {
        const tokenObservable = new rxjs_1.Subject();
        const onTokenUpdate = (newToken) => {
            const oldToken = this.token;
            this.token = newToken;
            tokenObservable.next({
                oldToken: oldToken,
                newToken: newToken
            });
        };
        this.ios.addEventListener(this.usePushkit ?
            'pushKitRegistered' : 'remoteNotificationsRegistered', onTokenUpdate);
        this.ios.addEventListener('remoteNotificationsRegistrationFailed', (error) => tokenObservable.error(error));
        return tokenObservable;
    }
    createMessageObservable() {
        const messageObservable = new rxjs_1.Subject();
        const onNotificationReceived = (notification) => {
            const data = notification.getData();
            data.payload = data.payload || notification.getMessage();
            const isPushKitMessage = notification.getPushType() !== undefined;
            if ((this.usePushkit && isPushKitMessage) ||
                (!this.usePushkit && !isPushKitMessage)) {
                messageObservable.next(data);
                return data.finish || data.payload.finish;
            }
            else {
                return undefined;
            }
        };
        this.ios.addEventListener('notificationReceivedBackground', onNotificationReceived);
        this.ios.addEventListener('notificationReceivedForeground', onNotificationReceived);
        return messageObservable;
    }
}
exports.IosNotifyWrapper = IosNotifyWrapper;
//# sourceMappingURL=ios-notify-wrapper.js.map